import CustomButton from "../components/CustomButton";
import groupUnitIcon from "../assets/new-ui/group-units-icon.png";
// import CustomSelection from '../components/CustomSelection'
import { useEffect, useState } from "react";
import Menu from "../components/Menu";
import ConnectWallet from "../components/ConnectWallet";
import ScrollTop from "../components/ScrollTop";
import { useAddress } from "../contexts/Context";
import { getWithdrawBalance, withdraw } from "../services/smartcontract";
import { BNB_DECIMAL } from "../constants/config";
import ModalWithdrawConfirm from "../components/withdraw/ModalWithdrawConfirm";
import ModalWithdrawResult from "../components/withdraw/ModalWithdrawResult";
import Bubble from "../components/coral/Bubble";

export default function Withdraw() {
  const currencyList = ["BNB"];
  const [currency, setCurrency] = useState(currencyList[0]);
  const [balance, setBalance] = useState(0);
  const [numberWithdraw, setNumberWithdraw] = useState(0);
  const [confirmBox, setConfirmBox] = useState(false);
  const [resultBox, setResultBox] = useState(false);
  const [processing, setProcessing] = useState(false);
  // const [value, setValue] = useState(0)
  const [address] = useAddress();
  useEffect(() => {
    //Get BNB balance
    // setBalance(100)
    // setNumberWithdraw(100)
    // if (currency === 'BNB') {
    //   setBalance(100)
    //   setNumberWithdraw(100)
    //   //Get BNB balance
    // }
    // else {
    //   setBalance(0)
    //   setNumberWithdraw(0)
    //   //Get HLS balance
    // }
  }, [currency]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (address) {
      getWithdrawBalance(address).then((result) => {
        setBalance(result / BNB_DECIMAL);
        setNumberWithdraw(result / BNB_DECIMAL);
      });
    }
  }, [address]);

  function handleWithdraw() {
    withdraw(address, setProcessing).then((result) => {
      if (result) {
        setProcessing(false);
        setConfirmBox(false);
        setResultBox(true);
      }
    });
  }
  return (
    <div className="withdrawContainer">
      <Menu />
      <ScrollTop />
      <ConnectWallet />

      <ModalWithdrawConfirm
        toggleModal={confirmBox}
        setToggleModal={setConfirmBox}
        fn={handleWithdraw}
        balance={balance}
        processing={processing}
      />

      <ModalWithdrawResult
        toggleModal={resultBox}
        fn={() => window.location.reload()}
      />
      <div className="pageTitle">Withdraw</div>
      <div className="withdrawContent">
        {/* <div className='currencyList'>
          <CustomSelection list={currencyList} setCurrent={setCurrency} innerWidth='100px' />
        </div> */}
        <div className="withdrawBalance">
          <div>Balance:</div>
          <div>
            {balance} {currency}
          </div>
        </div>
        <div className="withdrawInput">
          <input placeholder="0000" value={numberWithdraw} disabled />
          <img src={groupUnitIcon} alt="unit icon" />
        </div>
        <CustomButton
          text="Withdraw"
          fn={() => (numberWithdraw > 0 ? setConfirmBox(true) : {})}
          disabled={numberWithdraw > 0 ? false : true}
        />
      </div>
      <div className="footer">
        <Bubble bottom={"5%"} />
        <div className="footerBrand">@Sharktopia 2021</div>
      </div>
    </div>
  );
}
